import $ from 'jquery';
import BackgroundImage from './BackgroundImage';

function Pods(element) {
  this.$element = $(element);
  this.$pods = this.getPods();
  this.process();
}

Pods.prototype = {
  getPods() {
    return this.$element.find('.views-row');
  },
  process() {
    this.$pods.each((i, element) => {
      // Add helper class to add pod w/image styling.
      if ($(element).find('.field-image').length) {
        element.backgroundImage = new BackgroundImage(element);
        $(element).addClass('image');
      }
      // Add helper class to add pod w/webform styling.
      if ($(element).find('.node-webform').length) {
        $(element).addClass('webform');
      }
    });

    // Add helper class to add pods' post processing styling.
    this.ready();
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Pods;



// WEBPACK FOOTER //
// ./Pods.js